import { useCallback, useEffect, useMemo } from 'react';
import { useOutsideFrameMessenger, useInsideFrameMessenger, simpleStateSetHandler } from './messengerHooks';
const dynamicStateMessageKey = 'dynamicState';
const contentMessageKey = 'content';
const errorMessageKey = 'error';
const noContentMessageKey = 'noContent';
const videoPlayMessageKey = 'videoPlay';
const videoFinishMessageKey = 'videoFinish';
export const useSyncDynamicState = ({
  newState,
  onContent,
  onError,
  onNoContent,
  onVideoPlay,
  onVideoFinish
}) => {
  const messageHandlers = useMemo(() => ({
    [contentMessageKey]: message => {
      onContent === null || onContent === void 0 || onContent(message);
    },
    [errorMessageKey]: () => {
      onError === null || onError === void 0 || onError();
    },
    [noContentMessageKey]: () => {
      onNoContent === null || onNoContent === void 0 || onNoContent();
    },
    [videoPlayMessageKey]: () => {
      onVideoPlay === null || onVideoPlay === void 0 || onVideoPlay();
    },
    [videoFinishMessageKey]: () => {
      onVideoFinish === null || onVideoFinish === void 0 || onVideoFinish();
    }
  }), [onContent, onError, onNoContent, onVideoPlay, onVideoFinish]);
  const {
    registerIFrame,
    sendMessage,
    isReady
  } = useOutsideFrameMessenger({
    key: 'dynamic',
    messageHandlers
  });
  useEffect(() => {
    if (newState && sendMessage && isReady) {
      sendMessage(dynamicStateMessageKey, newState);
    }
  }, [isReady, newState, sendMessage]);
  return {
    registerIFrame
  };
};
const syncDynamicInsideHandlers = {
  [dynamicStateMessageKey]: simpleStateSetHandler
};
export const useSyncDynamicStateInsideIFrame = () => {
  const {
    state,
    sendMessage
  } = useInsideFrameMessenger({
    key: 'dynamic',
    messageHandlers: syncDynamicInsideHandlers
  });
  const onContent = useCallback(content => {
    sendMessage(contentMessageKey, content);
  }, [sendMessage]);
  const onError = useCallback(() => {
    sendMessage(errorMessageKey, {});
  }, [sendMessage]);
  const onNoContent = useCallback(() => {
    sendMessage(noContentMessageKey, {});
  }, [sendMessage]);
  const onVideoPlay = useCallback(() => {
    sendMessage(videoPlayMessageKey, {});
  }, [sendMessage]);
  const onVideoFinish = useCallback(() => {
    sendMessage(videoFinishMessageKey, {});
  }, [sendMessage]);
  return {
    state,
    onContent,
    onError,
    onNoContent,
    onVideoPlay,
    onVideoFinish
  };
};